import Select, { components } from "react-select";
import { Children, FC } from "react";
import colors from "tailwindcss/colors";
import Colors from "../../constants/colors";

const { ValueContainer, Placeholder } = components;

const CustomValueContainer: FC<any> = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {Children.map(children, (child) => (child && child.type !== Placeholder ? child : null))}
    </ValueContainer>
  );
};

type StyledSelectWoControllerProps = {
  options: { value: string; label: string }[];
  onChange: (e: any) => void;
  className?: string;
  placeholder: string;
  isClearable?: boolean;
  value?: string;
  isSearchable?: boolean;
  height?: string;
};

export const StyledSelectWoController = ({
  options,
  onChange,
  className,
  placeholder,
  isClearable = true,
  isSearchable = true,
  value,
  height,
}: StyledSelectWoControllerProps) => {
  return (
    <Select
      placeholder={placeholder}
      isClearable={isClearable}
      isSearchable={isSearchable}
      components={{
        IndicatorSeparator: () => null,
        ValueContainer: CustomValueContainer,
      }}
      value={
        value
          ? {
              value: value,
              label: value ? options.find((el) => el.value === value)?.label : "",
            }
          : undefined
      }
      options={options}
      onChange={onChange}
      className={className}
      menuPortalTarget={document.body}
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          borderColor: colors.gray[300],
          height: height || "3rem",
          borderRadius: "0.5rem",
        }),
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          transform: "translateY(0)",
          display: state.hasValue ? "none" : "block",
          fontSize: "0.9rem",
          fontWeight: "400",
          color: Colors.gray400,
        }),
        valueContainer: (baseStyles) => ({
          ...baseStyles,
          overflow: "visible",
          marginLeft: "0.4rem",
        }),
        singleValue: (baseStyles) => ({
          ...baseStyles,
        }),
        menuPortal: (provided) => ({
          ...provided,
          zIndex: 9999,
        }),
      }}
    />
  );
};
